module.exports = __webpack_public_path__ + "img/mobile-menu.0ce7bc28.svg";